export default {
  BOTAO_NAVBAR: {
    nome: 'botaoNavbar',
    evento: 'visualizouBotaoNavbar'
  },
  BOTAO_FORMULARIO_API: {
    nome: 'botaoFormularioApi',
    evento: 'visualizouBotaoFormularioApi'
  },
  MODAIS_PAGINAS_PUBLICAS: {
    nome: 'modalPaginaPublica',
    // evento: 'visualizouModalPaginaPublica'
    evento: ''
  },
  PAGINAS_SOLICITACAO_AUTOS: {
    nome: 'paginasSolicitacaoAutos',
    // evento: 'visualizouPaginasSolicitacaoAutos'
    evento: ''
  },
  TITULOS_PAGINA_API: {
    nome: 'titulosPaginaApi',
    evento: ''
  },
}
